<template>
    <div class="one-to-one__section">

        <div class="grid">
            <div
                class="grid__item medium--6"
                v-if="dataReceive">
                <h2 class="one-to-one__section-title">{{ $t("what-you-get") }}</h2>

                <button
                    @click="openModal('receive')"
                    class="button--trait-circle gift-circle button button--transparent"
                    :style="`background-color: #${ dataReceive.couleur };`">
                    {{ capitalize(dataReceive.Gift_short) }}
                </button>
            </div>

            <div
                class="grid__item medium--6"
                v-if="dataGift">
                <h2 class="one-to-one__section-title">{{ $t("what-you-give") }}</h2>

                <button
                    @click="openModal('gift')"
                    :style="`background-color: #${ dataGift.couleur };`"
                    class="button--trait-circle gift-circle button button--transparent">
                    {{ capitalize(dataGift.Gift_short) }}
                </button>
            </div>
        </div>

        <modal
            v-if="isModalVisible"
            class="modal"
            :title="modalTitle"
            :title-hidden="false"
            @closeModal="closeModal">

            <p v-html="modalContent"></p>

        </modal>
    </div>
</template>

<script>

import Modal from "@/components/modals/Modal.vue";

export default {
    name: "GiftSection",
    components: {
        Modal: Modal
    },
    props: {
        giftsData: {
            type: Array,
            required: true
        },
    },
    data () {
        return {
            modalTitle: null,
            modalContent: null,
            isModalVisible: false
        };
    },
    computed: {
        dataGift() {
            const gift = this.giftsData.filter((item) => {
                return item.type === "gift";
            });

            return gift[0];
        },
        dataReceive() {
            const receive = this.giftsData.filter((item) => {
                return item.type === "receive";
            });

            return receive[0];
        }
    },
    mounted: function() {
    },
    methods: {
        closeModal() {
            this.isModalVisible = false;
        },
        openModal(type) {

            switch (type) {
            case "gift":
                this.modalTitle = this.capitalize(this.dataGift.Gift_short);
                this.modalContent = this.capitalize(this.dataGift.desc);
                break;
            case "receive":
                this.modalTitle = this.capitalize(this.dataReceive.Gift_short);
                this.modalContent = this.capitalize(this.dataReceive.desc);
                break;
            }

            this.isModalVisible = true;
        }
    }
};

</script>